import { ArrowLongRightIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import Link from "next/link";

type ArrowLinkButtonProps = {
  href: string;
  label: string;
  description?: string;
  className?: string;
  compact?: boolean;
};

export const ArrowLinkButton: React.FC<ArrowLinkButtonProps> = ({
  href,
  label,
  description,
  className,
  compact = false,
}) => {
  return (
    <Link
      href={href}
      className={clsx(
        "group border-[#E5E7EB] bg-white text-[#0C1F3F] shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-[#00A87A] hover:bg-[#E8FAF4] hover:text-[#0C1F3F] hover:shadow-md",
        compact
          ? "flex w-full items-center justify-between rounded-lg border px-3 py-2 text-sm font-medium hover:scale-[1.02]"
          : "flex w-full items-center justify-between rounded-lg border px-6 py-3.5 text-sm font-medium hover:scale-[1.02]",
        className
      )}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2 pr-4 text-left">
        <span>{label}</span>
        {description ? (
          <span className="text-xs text-[#5C6370] transition-colors duration-300 group-hover:text-[#00A87A]">
            {description}
          </span>
        ) : null}
      </div>
      <ArrowLongRightIcon
        className={clsx(
          "flex-shrink-0 text-[#5C6370] transition-all duration-300 group-hover:translate-x-1.5 group-hover:text-[#00A87A]",
          compact ? "h-4 w-4" : "h-5 w-5 -translate-x-0.5"
        )}
        aria-hidden="true"
      />
    </Link>
  );
};
